(function ($) {

    /**
     * Set up defaults for Foundation
     *
     */
    Foundation.DropdownMenu.defaults.disableHover = true;
    Foundation.DropdownMenu.defaults.clickOpen = true;
    Foundation.DropdownMenu.defaults.closeOnClick = true;
    //Foundation.Reveal.defaults.appendTo = '.site-wrap';

    /**
     * This initializes Foundation
     * 
     */
    $(document).foundation();


    /**
     * Initializes waves.js and binds it to elements
     * 
     */
    Waves.attach('.menu a', '');
    Waves.attach('.button:not(input)', 'waves-light');
    Waves.attach('.fl-button', 'waves-light');
    Waves.init();


    /**
     * Header Overlay
     * 
     * Adds padding to compensate an absolute positioned site header.
     * It looks for the "overlay" class on #site-header.
     */
    if ($("#site-header").is(".overlay")) {

        /**
         * Header padding resizer thing.
         *
         * Gets the site header height and offsets the page title and some other
         * things so that it looks OK.
         *
         * @method padHeader
         * @return void
         */
        function padHeader() {

            // Declare and initialize
            var headHeight = $(".site-header").outerHeight(true) + 'px';
            var elements   = [
                '.page-title-default .page-content',
                '.page-title-top .page-header',
                '.no-page-title .fl-builder-content > .fl-row:first-child .fl-row-content'
            ];

            // Avoid a loop for now
            $(elements[0]).css('padding-top', headHeight);
            $(elements[1]).css('padding-top', headHeight);
            $(elements[2]).css('padding-top', headHeight);

            console.log(headHeight);
        }

        // Run the initial padding set
        padHeader();

        // Set our timeout variables
        var headerPadder;
        var timeout = 250;

        // Run when the window resizes
        window.onresize = function () {

            // Clear the timer in case we just resized a second ago
            clearTimeout(headerPadder);

            // Wait {timeout}ms before resizing
            headerPadder = setTimeout(padHeader, timeout);
        };

        // Run when image loads
        var logo    = new Image();
        logo.src    = $("#site-header .logo-image img").attr("src");
        logo.onload = padHeader;
    }


    /**
     * Adding active classes to inputs for different styling.
     */
    $('input').on('focus', function() {
    	$(this).parent().addClass('focused');
    });
    
    $('input').on('input', function() {
    	if($(this).val() == '') {
    		$(this).parent().removeClass('active');
    	} else {
    		$(this).parent().addClass('active');
    	}
    });
    
    $('input').on('blur', function() {
    	$(this).parent().removeClass('focused');
    	
    	if($(this).val() == '') {
    		$(this).parent().removeClass('active');
    	}
    });
    
    $(document).ready(function() {
    	$('input').each(function () {
    		if($(this).val() == '') {
    			$(this).parent().removeClass('active');
    		} else {
    			$(this).parent().addClass('active');
    		}
    	});
    });


    /**
     * Open a payment modal by adding a class to WP menu.
     */

    // Binds the class of "payment" to the modal of "payment"
    $(".payment").click(function(){
        $('#payment').foundation('open');
        $('#payment').find('form').removeClass().addClass('form-default');
    });


    /**
     * Opens the payment modal based off a URL query
     * 
     * @see http://codepen.io/bobsawyer/full/YyNmMj/?showModal=yes
     */
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }

    if (window.location.search) {
        var payment = getQueryVariable('payment');
        if (payment == 'true') {
            $('#thankyou').foundation('open');
        }
    }

    /**
     * Controls the windows when using the social share buttons
     * 
     */
    $('body').on('click', '.entry-social-item', function(e) {
        e.preventDefault();
        var data = $(this).attr('data-url');
        p3_social_share(data);
    });

    /* Share popup function */
    function p3_social_share(data) {
        window.open(data, "Share", 'height=500,width=760,top=' + ($(window).height() / 2 - 250) + ', left=' + ($(window).width() / 2 - 380) + 'resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0');
    }


$('[data-p3-toc]').each(function(){
    
    // Declare and initialize
    var toc        = $(this);
    var identifier = toc.data('p3-toc');
    var content    = $('[data-p3-toc-content="'+identifier+'"]');
    
    // We need content to continue
    if(!content.length) return;
    
    // Retrieve the headings therein
    var headings = content.find('h1, h2, h3, h4, h5, h6');
    var target   = toc;
    var depth    = 1;
    
    // Start interating through the headings
    for(var i = 0; i < headings.length; i++){
      
      // Extrapolate the heading level
      var heading = $(headings[i]);
      var hash    = Math.random().toString(16).substring(7);
      var id      = heading.attr('id') || 'toc-' + hash;
      var level   = parseInt(heading.prop('tagName')[1]);
      var label   = heading.text();
      var anchor  = $('<a>').attr('href', '#' + id).text(label);
      var item    = $('<li>').append(anchor);
      var change  = level - depth;

      // If the depth increased, created a new nested list
      if(0 < change){
        
        // Create the nested list
        var container = target.children().last();
        var nest      = $('<ul class="menu vertical nested">');
        
        // Add the nest to the container
        container.append(nest);
        
        // Set the nest as the new append target
        target = nest;
        
      }
      
      // If the depth decreased, start stepping out
      if(0 > change){
        
        while (0 !== change++) {
            target = target.parent().parent();
        }
        
      }
      
      // Update our active depth record
      depth = level;
      
      // Set the heading ID (the original ID is reused if available)
      heading.attr('id', id);
      
      // Insert the list item into the table of contents
      target.append(item);
      
    }
    
  })
//   .on('click', 'a', function(){
    
//     // Remove "active" class from other anchors
//     var toc      = $(this).closest('[data-p3-toc]');
//     var inactive = toc.find('.active').removeClass('active');
//     var parent   = $(this).parent('li').addClass('active');
    
//     // Get all parent lists as well
//     parent.parents('li').addClass('active');
    
//   });
  
  
  
})(jQuery);
